import { MAX_GRID_WIDTH } from "config/styleConsts";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import useDeviceSize from "hooks/useDeviceSize";
import {
  ChakraFlex as Flex,
  ChakraBox as Box,
  ChakraHeading as Heading,
  ChakraSimpleGrid as SimpleGrid,
} from "@airhelp/react-ui-components";
import TrustpilotAdapter from "modules/storyblok/adapters/Trustpilot";
import { TrustpilotTestimonial } from "components";
import type { AboutUsTrustpilotProps } from "./AboutUsTrustpilot.d";
import { background, textStyles } from "./AboutUsTrustpilot.styles";

export const AboutUsTrustpilot = ({
  title,
  subtitle,
  srcDesktop,
  srcMobile,
  height,
  alt,
  cardDesktopPosition = "left",
}: AboutUsTrustpilotProps) => {
  const { isTabletOrDesktop } = useDeviceSize();

  return (
    <Box
      pt={{ base: 9, md: 8 }}
      pb={{ base: 9, md: 20, lg: 8 }}
      maxW={MAX_GRID_WIDTH}
      px={{ base: 4, md: 6, lg: 8 }}
      mx={{ md: 4, xl: "auto" }}
      borderRadius={{ base: "none", md: "xl" }}
      {...background}
    >
      <SimpleGrid
        templateColumns={{ base: "1fr", md: "50% 46%" }}
        gap={6}
        justifyContent="space-between"
        alignItems="center"
      >
        <Flex
          align={{ base: "center", md: "flex-start" }}
          direction="column"
          textAlign="start"
          maxWidth={{ base: "none", md: "320px", lg: "400px" }}
          justifySelf="center"
          mt={{ md: 10, lg: 0 }}
        >
          {isTabletOrDesktop && <TrustpilotAdapter />}
          {title && (
            <Heading variant="h2" color="primary.900" my={{ base: 0, md: 4, lg: 6 }}>
              {title}
            </Heading>
          )}
          {isTabletOrDesktop && subtitle && <RichtextAdapter content={subtitle} customStyles={textStyles} />}
        </Flex>
        {srcDesktop && (
          <TrustpilotTestimonial
            srcDesktop={srcDesktop}
            srcMobile={srcMobile}
            height={height}
            alt={alt}
            cardDesktopPosition={cardDesktopPosition}
          />
        )}
      </SimpleGrid>
    </Box>
  );
};
